import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=9397b7e4&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/layout.css?vue&type=style&index=0&id=9397b7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9397b7e4",
  null
  
)

export default component.exports